module.exports = __webpack_public_path__ + "static/media/close.4befe4c1.svg";